import { UNWALKABLE } from 'helpers/constants';
import * as Movement from 'helpers/movementHelpers';
import { rand } from 'helpers/sharedHelpers';
import { getLevelState, setLevelState } from 'helpers/historyHelpers';
import { RED_PIECES, BLUE_PIECES, COLORLESS_PIECES } from './constants';

export const getDirection = (origin, destination) => {
  let direction = [];
  if (destination.x > origin.x) {
    direction[0] = 1;
  } else if (destination.x === origin.x) {
    direction[0] = 0;
  } else if (destination.x < origin.x) {
    direction[0] = -1;
  }
  if (destination.y > origin.y) {
    direction[1] = 1;
  } else if (destination.y === origin.y) {
    direction[1] = 0;
  } else if (destination.y < origin.y) {
    direction[1] = -1;
  }
  return direction;
};

export const queensFire = (map, origin, destination) => {
  const fireSet = [];
  const direction = getDirection(origin, destination);

  map.scene.game.soundManager.playSfx('queensFire', 0.6);
  //regress in direction from origin until we hit destination
  const moveTowardDest = (currentTile, destination) => {
    //move on if we're not at destination...
    if (currentTile.x !== destination.x || currentTile.y !== destination.y) {
      //set current tile as "on fire"
      fireSet.push({ x: currentTile.x, y: currentTile.y });
      const tile = map.putTileAt(
        UNWALKABLE,
        currentTile.x,
        currentTile.y,
        true,
        'logic_layer'
      );
      // map.putTileAt(378, currentTile.x, currentTile.y, true, 'above_player');
      tile.fire = map.scene.add
        .sprite(tile.pixelX + 32, tile.pixelY, 'anim_fire')
        .setDepth(4)
        .setOrigin(0);
      const config = `fire${fireSet.length}`;
      map.scene.anims.create({
        key: config,
        frames: map.scene.anims.generateFrameNumbers('anim_fire', {
          frames: randFlameStarts[rand(0, 2)]
        }),
        frameRate: 8,
        // delay: fireSet.length * 15,
        yoyo: false,
        repeat: -1
      });
      tile.fire.anims.load(config);
      tile.fire.anims.play(config);

      const nextTile = {
        x: currentTile.x + direction[0],
        y: currentTile.y + direction[1]
      };
      moveTowardDest(nextTile, destination);
    }
  };

  moveTowardDest(origin, destination);

  window.addEventListener('checkNextTurn', checkQueensFire, false);
  return { tiles: fireSet, counter: 3 };
};

export const checkQueensFire = event => {
  const { scene } = event.detail;
  const { fireSets, map } = scene;
  if (fireSets && fireSets.length) {
    let toBeRemoved;
    fireSets.forEach((fireSet, index) => {
      fireSet.counter -= 1;
      if (fireSet.counter < 1) {
        toBeRemoved = index;
        fireSet.tiles.forEach(tile => {
          const logicTile = map.getTileAt(tile.x, tile.y, true, 'logic_layer');
          // map.removeTileAt(tile.x, tile.y, false, true, 'above_player');
          if (logicTile.fire) {
            logicTile.fire.anims.stop();
            logicTile.fire.destroy();
          }
          map.removeTileAt(tile.x, tile.y, false, true, 'logic_layer');
        });
      }
    });
    if (toBeRemoved || toBeRemoved === 0) {
      fireSets.splice(toBeRemoved, 1);
      if (fireSets.length < 1) {
        window.removeEventListener('checkNextTurn', checkQueensFire);
      }
    }
  }
};

const randFlameStarts = {
  0: [0, 1, 2],
  1: [1, 2, 0],
  2: [2, 0, 1]
};

export const ForestBow = {
  init: scene => {
    if (scene) {
      if (!scene.plant_grow) {
        scene.plant_grow = scene.anims.create({
          key: 'plant_grow',
          frames: scene.anims.generateFrameNumbers('plant_grow'),
          frameRate: 12,
          yoyo: false,
          repeat: 0,
          hideOnComplete: true
        });
      }
      if (!scene.fire_bow) {
        scene.fire_bow = scene.anims.create({
          key: 'fire_bow',
          frames: scene.anims.generateFrameNumbers('fire_bow'),
          frameRate: 8,
          yoyo: false,
          repeat: 0
        });
      }
    }
  },
  cancel: scene => {
    scene.projectileAiming = false;
    scene.projectileTargets = [];
    Movement.clearTileHighlighting(scene.map);
    scene.pickupUnit(scene.currentSelectedPiece);
  },
  aim: (scene, originTile) => {
    // set flag for generic click to select tile to fire upon, or disable targeting and flag
    scene.projectileAiming = true;
    scene.projectileTargets = [];
    Movement.clearTileHighlighting(scene.map);

    // set tiles that can be hit
    scene.projectileTargets = getPossibleBowTargets(originTile, scene);
    Movement.setTilesHighlightedForProjectile(
      scene.projectileTargets,
      scene.map
    );
  },
  serverFire: (room, actionData) => {
    const { dest } = actionData;
    const { p1MapData, map, pieces } = room;
    const destIndex = dest.x + dest.y * map.width;
    const destTileIndex = p1MapData[destIndex];

    //check if the target tile is occupied!
    if (
      RED_PIECES.concat(BLUE_PIECES, COLORLESS_PIECES).includes(destTileIndex)
    ) {
      const hitPieceIndex = pieces.findIndex(
        piece => piece.x === dest.x && piece.y === dest.y
      );
      const hitPiece = pieces[hitPieceIndex];
      if (hitPiece.hp && hitPiece.hp > 1) {
        hitPiece.hp--;
      } else {
        pieces.splice(hitPieceIndex, 1);
        //place logic tile unwalkable for the tree
        let newMapData = p1MapData.slice();
        newMapData[destIndex] = UNWALKABLE;
        room.p1MapData = newMapData;
      }
    }
  },
  fire: (scene, originTile, targetTile, cb) => {
    Movement.clearTileHighlighting(scene.map);
    scene.projectileAiming = false;
    scene.projectileTargets = [];
    originTile.occupant.itemActive = false;
    // trigger shooting animation
    let bow = scene.add
      .sprite(originTile.pixelX + 40, originTile.pixelY + 32, 'fire_bow')
      .setDepth(17)
      .setOrigin(0);
    bow.anims.load('fire_bow');
    bow.anims.play('fire_bow');
    scene.game.soundManager.playSfx('seedShot');
    bow.on('animationcomplete', (anim, frame) => {
      // trigger growth animation
      let grow = scene.add
        .sprite(targetTile.pixelX + 32, targetTile.pixelY, 'plant_grow')
        .setDepth(17)
        .setOrigin(0);
      grow.on('animationcomplete', () => {
        grow.destroy();
        bow.destroy();
        const targetPiece = targetTile.occupant;
        const rebuffed = targetPiece && targetPiece.hp && targetPiece.hp > 1;
        if (!rebuffed) {
          // add random tree to map
          const randomIndex = rand(0, 2);
          const treeSpriteIndexes = [424, 429, 430];
          const treeBase = treeSpriteIndexes[randomIndex];
          scene.map.putTileAt(
            treeBase,
            targetTile.x,
            targetTile.y,
            true,
            'below_player'
          );
          scene.map.putTileAt(
            treeBase - 18,
            targetTile.x,
            targetTile.y - 1,
            true,
            'above_player'
          );
          scene.map.putTileAt(
            UNWALKABLE,
            targetTile.x,
            targetTile.y,
            true,
            'logic_layer'
          );
        }
        // if unit occupies space...
        if (targetTile.occupant) {
          // and doesn't have HP to rebuff
          if (!rebuffed) {
            scene.animateDeath(
              true,
              targetTile.occupant.color === 'red',
              targetTile,
              false,
              () => {
                let deadPiece = targetTile.occupant;
                const pieceIndex = deadPiece.pieceIndex;
                const gameMenu = scene.scene.get('GameMenuScene');
                scene.captured[deadPiece.color].push({
                  index: pieceIndex,
                  id: deadPiece.id,
                  turnIndex: gameMenu.turnNumber
                });
                if (scene.previousSelectedPiece === deadPiece) {
                  scene.previousSelectedPiece = null;
                }
                if (scene.currentSelectedPiece === deadPiece) {
                  scene.currentSelectedPiece = null;
                }
                deadPiece.parentContainer.destroy();
                if (cb) {
                  cb();
                }
              }
            );
          } else {
            targetTile.occupant.hp -= 1;
            scene.showHitPointsUI(targetTile);
          }
        } else {
          if (cb) {
            cb();
          }
        }
      });

      grow.anims.load('plant_grow');
      grow.anims.play('plant_grow');

      // specific to bow shrine in campaign
      const pieceWithBow = scene.pieces.getChildren().find(piece => {
        return piece.itemID && piece.itemID === 5;
      });
      if (scene.scene.key === 'CastleScene' && scene.levelData.id === 4) {
        if (targetTile.x === 14 && targetTile.y === 14 && pieceWithBow) {
          setLevelState(scene, 'hitFirstTarget', true);
        }
        if (
          targetTile.x === 10 &&
          targetTile.y === 14 &&
          pieceWithBow &&
          getLevelState(scene, 'triggeredSecondTrap')
        ) {
          setLevelState(scene, 'hitSecondTarget', true);
        }
      }

      // specific to ancient ruins portal
      if (scene.scene.key === 'WorldScene') {
        if (targetTile.x === 119 && targetTile.y === 119) {
          scene.hitAncientRuinsTarget = true;
        }
      }
    });
  }
};

export function getPossibleBowTargets(originTile, scene) {
  const targets = [];
  const range = { min: 2, max: 4 };
  const start = { x: originTile.x - range.max, y: originTile.y - range.max };
  const end = { x: originTile.x + range.max, y: originTile.y + range.max };
  for (let x = start.x; x <= end.x; x++) {
    for (let y = start.y; y <= end.y; y++) {
      const dist = Math.sqrt(
        Math.pow(originTile.x - x, 2) + Math.pow(originTile.y - y, 2)
      );
      const inRange = dist <= range.max && dist >= range.min;
      if (inRange) {
        const targetTile = scene.map.getTileAt(x, y, true, 'logic_layer');
        if (targetTile && targetTile.index !== UNWALKABLE) {
          targets.push(targetTile);
        }
      }
    }
  }

  return targets;
}
